import { z } from 'zod';

export const CampaignManagerIntegrationSchema = z.object({
  id: z.number(),
  name: z.string(),
  account: z.number().nullable(),
  profileId: z.number(),
  integrationType: z.literal('ad_server'),
  platform: z.literal('campaign_manager'),
  dv360Linkage: z.boolean(),
  advertiserIds: z.array(z.string()),
  attributionModelId: z.string().nullable(),
  isActive: z.boolean(),
  isOauthConnected: z.boolean(),
  usingInCampaigns: z.boolean().optional(),
});

export const CmIntegrationsResponseSchema = z.object({
  isBothSidesIntegration: z.boolean(),
  count: z.object({
    adServer: z.number(),
  }),
  integrations: z.array(CampaignManagerIntegrationSchema),
});
